import React from 'react';

import SimpleImage from './image-simple.jsx';
import Video from './video.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Media}
 */
const Media = ({
    image,
    imageComponent = SimpleImage,
    video,
    videoComponent = Video,
    videoEmbed,
    videoEmbedComponent = Video
}) => {
    let Component;
    let props;

    if (video) {
        Component = videoComponent;
        props = video;
    } else if (videoEmbed) {
        Component = videoEmbedComponent;
        props = videoEmbed;
    } else if (image) {
        Component = imageComponent;
        props = image;
    }

    return (
        <Component {...props} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Media;
